import { useState, useEffect } from 'react';
import "../../templates/Templates.css";
import "../../templates/tables/Table.css";
import "../ComponentsGlobalStyle.css";
import * as con from '../../GlobalConstants';
import { GenericCell } from '../../templates/tables/Cells';
import { RefSPOT } from '../hooks/MarketValuesHook';

function FirstLeftTable({ data }) {
    const spot = RefSPOT();
    const [styles, setStyles] = useState({ fontSize: '12px', padding: '5px 10px' });
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const apertura = data.apertura;
    
    const safeCalculation = (fn) => {
        try {
            const result = fn();
            return isNaN(result) || result === Infinity || result === -Infinity ? '-' : result;
        } catch (error) {
            return '-';
        }
    };
    
    const volatilidadJornada = safeCalculation(() => spot - apertura);
    const volatilidadJornadaPorcentaje = safeCalculation(() => (spot / apertura) - 1) ;
    const adjustStyles = () => {
        const width = window.innerWidth;
        const newStyles = {
            fontSize: width < 400 ? '9px' : width < 768 ? '11px' : '14px',
            padding: width < 400 ? '3px 5px' : width < 768 ? '4px 8px' : '5px 10px',
        };
        setStyles(newStyles);
        setIsSmallScreen(width < 768);
    };

    useEffect(() => {
        adjustStyles();
        window.addEventListener('resize', adjustStyles);
        return () => window.removeEventListener('resize', adjustStyles);
    }, []);

    const formatHour = (timeString) => {
        if (!timeString) return "";

        const hour = parseInt(timeString.split(":")[0], 10);
        const suffix = hour < 12 ? "AM" : "PM";

        return `${timeString} ${suffix}`;
        };

    return (
        <div className="contenedor-tabla" style={{ fontSize: styles.fontSize, padding: '0 10px', marginBottom: '15px' }}>
            <div className="flex-tabla">
                <div className="flex-fila header-row" style={{ padding: styles.padding }}>
                    <div className="flex-celda">ÚLTIMO</div>
                    {!isSmallScreen && <div className="flex-celda">MAX</div>}
                    {!isSmallScreen && <div className="flex-celda">MIN</div>}
                    <div className="flex-celda">APERTURA</div>
                </div>
            </div>

            <div className="flex-tabla">
                <div className="flex-fila" style={{ padding: styles.padding }}>
                    <div className="flex-celda">
                        <GenericCell cellType={con.MONEY} allowDecimals ={true} value={spot} editing={false} />
                    </div>
                    {!isSmallScreen && <div className="flex-celda">
                        <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.maximo} editing={false} />
                    </div>}
                    {!isSmallScreen && <div className="flex-celda">
                        <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.minimo} editing={false} />
                    </div>}
                    <div className="flex-celda">
                        <GenericCell cellType={con.MONEY} allowDecimals ={2} value={data.apertura} editing={false} />
                    </div>
                </div>
                <div className="flex-fila uneven-row" style={{ padding: `1px 10px`, textAlign: 'center', fontSize: styles.fontSize }}>
                    {!isSmallScreen && (
                        <div className="flex-celda" style={{ padding: styles.padding }}>
                            <GenericCell cellType={con.TEXT} value={" "} editing={false} />
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda" style={{ padding: styles.padding }}>
                        <GenericCell cellType={con.TEXT} value={formatHour(data.max_time)} editing={false} />
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda" style={{ padding: styles.padding }}>
                            <GenericCell cellType={con.TEXT} value={formatHour(data.min_time)} editing={false} />
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda" style={{ padding: styles.padding }}>
                            <GenericCell cellType={con.TEXT} value={formatHour(data.apertura_time)} editing={false} />
                        </div>
                    )}
                </div>
            </div>
            <br></br>
            <div className="flex-tabla">
                <div className="flex-fila header-row" style={{ padding: styles.padding }}>
                    <div className="flex-celda">TRM</div>
                    <div className="flex-celda">VOLUMEN (MILES)</div>
                    <div className="flex-celda">PROMEDIO JORNADA</div>
                    <div className="flex-celda">VOLATILIDAD JORNADA</div>
                </div>
            </div>

            <div className="flex-tabla">
                <div className="flex-fila" style={{ padding: styles.padding }}>
                    {!isSmallScreen &&(
                        <div className="flex-celda" style={{ padding: styles.padding }}>
                            <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.trm_real} editing={false} />{"(Hoy)"}
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda">
                            <GenericCell cellType={con.MONEY} currency = {con.MONEY_USD} allowDecimals ={true} value={data.volumen} editing={false} />
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda">
                            <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.promedio} editing={false} />
                        </div>
                    )}
                    {!isSmallScreen &&(
                        <div className="flex-celda">
                            <GenericCell cellType={con.MONEY} currency = {con.MONEY_COP} allowDecimals ={true} value={volatilidadJornada} editing={false} />
                        </div>
                    )}
                </div>
            </div>
            <div className="flex-fila uneven-row" style={{ padding: styles.padding }}  title="TRM estimada para el día siguiente">
                <div className="flex-celda" style={{ padding: styles.padding }}>
                    <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.trm_volumen} editing={false} />{"\u00A0(Est.)"}

                </div>
                {!isSmallScreen &&(
                    <div className="flex-celda" style={{ padding: styles.padding }}>
                      <GenericCell cellType={con.TEXT} value={" "} editing={false} />
                    </div>
                )}
                {!isSmallScreen &&(
                    <div className="flex-celda" style={{ padding: styles.padding }}>
                        <GenericCell cellType={con.PERCENTAGE} decimalScale = {2} value={data.promedio_percentage/100} editing={false} />
                    </div>
                )}
                {!isSmallScreen &&(
                    <div className="flex-celda" style={{ padding: styles.padding }}>
                        <GenericCell cellType={con.PERCENTAGE} decimalScale = {2} value={volatilidadJornadaPorcentaje} editing={false} />
                    </div>
                )}
            </div>
        </div>
        
    );
}

export default FirstLeftTable;
